module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/hbhbY5/tc-custom/9781426852985.jpg?1727649961324",
      "alt": "This image is the cover for the book Unmasking Lady Innocent, Undone!"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Unmasking Lady Innocent, Undone!\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Spinster Diana Buntin has accepted that handsome Lord James Grey will never look at her as more than a friend. Yet she is tired of waiting to experience passion. Armed with a list of rakes known to specialize in seduction, Diana arranges to meet her first lover at a masked ballkeeping their identities secret and her reputation intact."), _c('br'), _c('br'), _vm._v("But while Diana feels a powerful attraction to her mystery seducer, she also senses that he may not be a stranger after all....")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ann Lethbridge\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Ann Lethbridge majored in history and business. She always loved the glamorous, if rather risky, Georgians and in particular the Regency era as drawn by Georgette Heyer. It was that love that prompted her to write her first Regency novel in 2000. She found she enjoyed it so much she just couldn’t stop! Ann gave up a career in university administration to focus on her first love, writing novels and lives in Canada with her family. Visit her website at: www.annlethbridge.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0